// ABOUTME: Where the TE store's shop shows: a .ru host — the store sells in Russia from a Russian storefront, and a .com
// ABOUTME: host is to get a shop of its own (docs/APP_SHOP_SPEC.md §5.8) — plus the beta build and a dev build.

import config from "@/config"
import { runtimeTld } from "@/model/domain"

/**
 * The beta build shows it on beta.trainingendurance.com too: the native apps load .com hosts only, and their beta
 * server is where the shop is checked in them. A dev build shows it on any host, as localhost counts as .com.
 */
export const teShopAvailable = (): boolean => runtimeTld() === "ru" || config.MODE === "beta" || config.IS_DEV
